import React from 'react';

import { Skeleton } from '@material-ui/lab';

import { IconTileSkeletonProps } from './IconTileSkeleton.types';

const IconTileSkeleton: React.FC<IconTileSkeletonProps> = ({
  className,
  height = 36,
  width = 36,
}) => {
  return (
    <div className={`flex ${className}`}>
      <Skeleton variant="rect" width={height} height={width} className="mr4 br2" />
    </div>
  );
};
export default IconTileSkeleton;
export { IconTileSkeletonProps };